// Menu Items - Same structure as original dashboard but with French labels
// roles: ['admin', 'manager', 'distributeur'] - qui peut voir ce menu
// Si roles n'est pas défini, tous les utilisateurs autorisés peuvent voir

export const MENU_ITEMS = [
  {
    key: 'general',
    label: 'GÉNÉRAL',
    isTitle: true
  },
  {
    key: 'dashboard',
    label: 'Tableau de Bord',
    icon: 'solar:widget-5-bold-duotone',
    url: '/admin/dashboard'
  },
  {
    key: 'products',
    label: 'Produits',
    icon: 'solar:t-shirt-bold-duotone',
    children: [
      {
        key: 'product-list',
        label: 'Liste',
        url: '/admin/products/product-list',
        parentKey: 'products'
      },
      {
        key: 'product-add',
        label: 'Créer',
        url: '/admin/products/product-add',
        parentKey: 'products'
      },
      
    ]
  },
  {
    key: 'family',
    icon: 'solar:users-group-rounded-bold-duotone',
    label: 'Familles',
    children: [
      {
        key: 'family-list',
        label: 'Liste',
        url: '/admin/families/family-list',
        parentKey: 'family'
      },
      {
        key: 'family-add',
        label: 'Créer',
        url: '/admin/families/family-add',
        parentKey: 'family'
      }
    ]
  },
  {
    key: 'category',
    icon: 'solar:clipboard-list-bold-duotone',
    label: 'Catégories',
    children: [
      {
        key: 'category-list',
        label: 'Liste',
        url: '/admin/categories/category-list',
        parentKey: 'category'
      },
      {
        key: 'category-add',
        label: 'Créer',
        url: '/admin/categories/category-add',
        parentKey: 'category'
      }
    ]
  },
  {
    key: 'warehouse',
    icon: 'solar:box-bold-duotone',
    label: 'Entrepôts',
    children: [
      {
        key: 'warehouse-list',
        label: 'Liste',
        url: '/admin/warehouses/warehouse-list',
        parentKey: 'warehouse'
      },
      {
        key: 'warehouse-add',
        label: 'Créer',
        url: '/admin/warehouses/warehouse-add',
        parentKey: 'warehouse'
      }
    ]
  },
  {
    key: 'orders',
    label: 'Commandes',
    icon: 'solar:bag-smile-bold-duotone',
    badge: {
      text: '0',
      variant: 'danger',
      dynamic: 'pending-orders'
    },
    children: [
      {
        key: 'orders-list',
        label: 'Liste',
        url: '/admin/orders/orders-list',
        parentKey: 'orders'
      },
      {
        key: 'order-add',
        label: 'Créer',
        url: '/admin/orders/order-add',
        parentKey: 'orders'
      }
    ]
  },
  {
    key: 'suppliers',
    label: 'Fournisseurs',
    icon: 'solar:buildings-bold-duotone',
    children: [
      {
        key: 'supplier-list',
        label: 'Liste',
        url: '/admin/suppliers/supplier-list',
        parentKey: 'suppliers'
      },
      {
        key: 'supplier-add',
        label: 'Créer',
        url: '/admin/suppliers/supplier-add',
        parentKey: 'suppliers'
      },
     
    ]
  },
  {
    key: 'packs',
    label: 'Pack Produit',
    icon: 'solar:box-minimalistic-bold-duotone',
    children: [
      {
        key: 'pack-list',
        label: 'Liste',
        url: '/admin/packs/pack-list',
        parentKey: 'packs'
      },
      {
        key: 'pack-add',
        label: 'Créer',
        url: '/admin/packs/pack-add',
        parentKey: 'packs'
      }
    ]
  },
  {
    key: 'offers',
    label: 'Offres',
    icon: 'solar:tag-price-bold-duotone',
    children: [
      {
        key: 'offer-list',
        label: 'Liste',
        url: '/admin/offers/offer-list',
        parentKey: 'offers'
      },
      {
        key: 'offer-add',
        label: 'Créer',
        url: '/admin/offers/offer-add',
        parentKey: 'offers'
      }
    ]
  },
  {
    key: 'customer',
    label: 'Clients',
    icon: 'solar:users-group-two-rounded-bold-duotone',
    children: [
      {
        key: 'customer-list',
        label: 'Liste',
        url: '/admin/customer/customer-list',
        parentKey: 'customer'
      },
      {
        key: 'customer-create',
        label: 'Créer',
        url: '/admin/customer/customer-create',
        parentKey: 'customer'
      },
     
    ]
  },
  {
    key: 'contacts',
    label: 'Messages',
    icon: 'solar:chat-dots-bold-duotone',
    url: '/admin/contacts',
    badge: {
      text: 'New',
      variant: 'info'
    }
  },
  {
    key: 'security-report',
    label: 'Rapport Sécurité',
    icon: 'solar:shield-warning-bold-duotone',
    url: '/admin/reports/security',
    roles: ['admin', 'manager']
  },
  {
    key: 'settings',
    label: 'Paramètres',
    icon: 'solar:settings-bold-duotone',
    url: '/admin/settings'
  },
  {
    key: 'OTHER',
    label: 'AUTRE',
    isTitle: true,
    roles: ['admin'] // Seulement pour admin
  },
  {
    key: 'reports',
    label: 'Rapports',
    icon: 'solar:chart-2-bold-duotone',
    roles: ['admin'], // Seulement pour admin - manager ne peut pas voir
    children: [
      {
        key: 'finance-report',
        label: 'Rapport Financier',
        url: '/admin/reports/finance',
        parentKey: 'reports',
        roles: ['admin']
      },
      {
        key: 'stock-report',
        label: 'Rapport de Stock',
        url: '/admin/reports/stock',
        parentKey: 'reports',
        roles: ['admin']
      },
     
    ]
  }
];

// Rôles autorisés à accéder au dashboard (pas client)
export const DASHBOARD_ALLOWED_ROLES = ['admin', 'manager', 'distributeur'];

// Fonction pour filtrer les menus selon le rôle
export const getMenuItemsForRole = (role) => {
  const filterByRole = (items) => {
    return items.filter(item => {
      // Si pas de roles défini, accessible à tous les utilisateurs du dashboard
      if (!item.roles) return true;
      // Si roles défini, vérifier si le rôle de l'utilisateur est inclus
      return item.roles.includes(role);
    }).map(item => {
      // Filtrer aussi les enfants
      if (item.children) {
        return {
          ...item,
          children: filterByRole(item.children)
        };
      }
      return item;
    });
  };
  
  return filterByRole(MENU_ITEMS);
};
